import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';
import IconBox from '../IconBox';

import './ListItem.scss';

const iconSizes = {
	small: 24,
	medium: 32,
	large: 40,
};

const ListItem = ({
	className,
	icon = null,
	iconLabel = null,
	iconSize = 'large',
	title = null,
	label = null,
	description = null,
	rightTitle = null,
	rightDescription = null,
	onSelect = () => {},
	bottomSeparator = false,
	trailing = [],
	glare = false,
	iconComponent = null,
}) => {
	return (
		<div className={classNames('ListItem', className)} onClick={onSelect}>
			{iconComponent
				? iconComponent
				: icon && (
						<IconBox
							className={`ListItem__${iconSize}-icon`}
							icon={icon}
							iconLabel={iconLabel}
							size={iconSizes[iconSize]}
						/>
				  )}
			<div className={classNames('ListItem__conteiner', { 'ListItem__bottom-separator': bottomSeparator })}>
				<div className='ListItem__content-block'>
					{(title || label) && (
						<div className='ListItem__header'>
							{title && <div className='ListItem__title'>{title}</div>}
							{typeof label === 'string' ? <div className='ListItem__label'>{label}</div> : label}
						</div>
					)}
					{description && <div className='ListItem__description'>{description}</div>}
				</div>
				{(rightTitle !== null || rightDescription !== null) && (
					<div className='ListItem__right-block'>
						{rightTitle !== null && <div className='ListItem__right-title'>{rightTitle}</div>}
						{rightDescription !== null && <div className='ListItem__right-description'>{rightDescription}</div>}
					</div>
				)}
				{trailing.map((item, index) => (
					<div key={index} className='ListItem__trailing-item'>
						{item}
					</div>
				))}
				{glare && (
					<div className='ListItem__glare'>
						<div className='ListItem__glare1' />
						<div className='ListItem__glare2' />
					</div>
				)}
			</div>
		</div>
	);
};

ListItem.propTypes = {
	className: PropTypes.string,
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	iconLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	iconSize: PropTypes.oneOf(Object.keys(iconSizes)),
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	rightTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	rightDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	onSelect: PropTypes.func,
	bottomSeparator: PropTypes.bool,
	trailing: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.node])),
	glare: PropTypes.bool,
};

export default ListItem;
